export const isLastItemArray = (index: number, array: ReadonlyArray<any>) => {
  return index === array.length - 1;
};
